import * as model from "./model.js";
import view from "./view.js";

 const newBtn =  document.querySelector('#new-btn')
export const init = async function () {
    // load from api
    await model.loadWords()
    // render the word
     view.renderWord({loadedWord:['x','x','x','x','x']});

    // handler
    view.adEventHandler((enteredWord)=>{
        if(model.state.player.win)return;
        model.check(enteredWord,model.state.loadedWord)
        view.renderLetters(model.state)
        view.updateGuess(model.state)
       
    })
    newBtn.addEventListener('click',()=>{
        window.location.reload()
    })
}



export default init;




